import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CompanyAccess } from '../../services/api-service';
import { SELECTED_PARTREF } from '../../utils/constants';
import { erInnlogget, hentTilganger, requestToken } from '../thunks/bruker';

interface BrukerState {
  erInnlogget: boolean;
  jwt?: string;
  tilganger?: CompanyAccess[];
  selectedTilgang?: CompanyAccess;
}

const initialState: BrukerState = {
  erInnlogget: false
};

const bruker = createSlice({
  name: 'bruker',
  initialState,
  reducers: {
    companySelect(state, action: PayloadAction<CompanyAccess>) {
      state.selectedTilgang = action.payload;
    },
    revertCompanySelection(state) {
      if (state.tilganger?.length && state.tilganger?.length > 1) {
        state.selectedTilgang = undefined;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(erInnlogget.fulfilled, (state, action) => {
        state.erInnlogget = action.payload;
      })
      .addCase(hentTilganger.fulfilled, (state, action) => {
        state.tilganger = action.payload;
        if (action.payload.length > 1 && SELECTED_PARTREF) {
          state.selectedTilgang = action.payload.find(
            (it) => it.partref === SELECTED_PARTREF
          );
        } else if (action.payload.length === 1) {
          state.selectedTilgang = action.payload[0];
        }
      })
      .addCase(requestToken.fulfilled, (state, action) => {
        state.jwt = action.payload;
      });
  }
});

export const { companySelect, revertCompanySelection } = bruker.actions;

export default bruker.reducer;
